export const FETCH_CITIES = "FETCH_CITIES"
export const CREATE_CITY = "CREATE_CITY"
export const UPDATE_CITY = "UPDATE_CITY"
export const DELETE_CITY = "DELETE_CITY"
export const UPDATE_CITY_ROW = "UPDATE_CITY_ROW"
export const FETCH_STREETS = "FETCH_STREETS"
export const CREATE_STREET = "CREATE_STREET"
export const UPDATE_STREET = "UPDATE_STREET"
export const DELETE_STREET = "DELETE_STREET"
export const GET_TREE = "GET_TREE"